// import React from 'react';
import React, { Suspense, lazy } from "react";
//import HomePage from "../components/HomePage/HomePage";
//import AboutPage from '../components/AboutPage/AboutPage';
// import NotFound from '../components/NotFound/NotFound';
import MainLayout from "../components/Layout/MainLayout";
import Vigilance from "../components/Vigilance";
// import Vigilance from "../components/Vigilance copy";
// import InnerPage from '../components/page/InnerPage';
// import HomePage from '../components/page/HomePage';
// import SearchPage from '../components/page/Template/SearchPage';

// Lazy load the components
const HomePage = lazy(() => import("../components/page/HomePage"));
const InnerPage = lazy(() => import("../components/page/InnerPage"));
const NotFound = lazy(() => import("../components/NotFound/NotFound"));
const SearchPage = lazy(() => import("../components/page/Template/SearchPage"));

export const routes = [
  {
    path: "/quiz",
    element: <Vigilance />,
  },
  {
    path: "/quiz/:language",
    element: <Vigilance />,
  },
  {
    path: "/",
    element: <MainLayout />,
    children: [
      {
        path: "/",
        // element: <HomePage />,
        element: (
          <Suspense fallback={<div></div>}>
            <HomePage />
          </Suspense>
        ),
      },
      {
        path: "/home/:language",
        // element: <HomePage />,
        element: (
          <Suspense fallback={<div></div>}>
            <HomePage />
          </Suspense>
        ),
      },
      {
        path: "/search",
        // element: <SearchPage />,
        element: (
          <Suspense fallback={<div></div>}>
            <SearchPage />
          </Suspense>
        ),
      },
      {
        path: "/search/:language",
        // element: <SearchPage />,
        element: (
          <Suspense fallback={<div></div>}>
            <SearchPage />
          </Suspense>
        ),
      },
      {
        path: "/:slug",
        // element: <InnerPage />,
        element: (
          <Suspense fallback={<div></div>}>
            <InnerPage />
          </Suspense>
        ),
      },
      {
        path: "/:slug/:language",
        // element: <InnerPage />,
        element: (
          <Suspense fallback={<div></div>}>
            <InnerPage />
          </Suspense>
        ),
      },
      {
        path: "404",
        // element: <NotFound />
        element: (
          <Suspense fallback={<div></div>}>
            <NotFound to="/404" />
          </Suspense>
        ),
      },
      {
        path: "*",
        // element: <NotFound />
        element: (
          <Suspense fallback={<div></div>}>
            <NotFound to="/404" />
          </Suspense>
        ),
      },
    ],
    loader: async () => {
      return false;
    },
  },
];
